import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { Overview } from './pages/Overview';
import { Placeholder } from './pages/Placeholder';
import { StaffRegistry } from './pages/StaffRegistry';
import { CertificatesDashboard } from './pages/dashboards/Certificates';
import { CustomerServiceDashboard } from './pages/dashboards/CustomerService';
import { PartnersDashboard } from './pages/dashboards/Partners';
import { TrainersDashboard } from './pages/dashboards/Trainers';

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Overview />} />
        <Route path="customer-service" element={<CustomerServiceDashboard />} />
        <Route path="trainers" element={<TrainersDashboard />} />
        <Route path="partners" element={<PartnersDashboard />} />
        <Route path="certificates" element={<CertificatesDashboard />} />
        <Route path="settings/staff" element={<StaffRegistry />} />
        <Route
          path="*"
          element={
            <Placeholder
              title="Not found"
              phase="—"
              description="The page you requested does not exist."
            />
          }
        />
      </Route>
    </Routes>
  );
}
